export const environment = {
    PRODUCT_MODE: false,
    // API_URL: 'http://45.117.82.172:8800',
    // API_URL: 'http://localhost:8800',
    API_URL: 'https://dev.ec-assign-apis.weset.edu.vn'
    // API_URL: 'https://dev.portal-apis.weset.edu.vn'
};
